/**
 * Workflow step names — display in the current UI language.
 *
 * Step names are free text stored on WorkflowStepDefinition.stepName, and the
 * defaults the backend seeds (user-service workflowService.js →
 * buildDefaultWorkflowTemplates) are English. This maps those known defaults
 * to Arabic so the Arabic UI never shows them in English. A custom name an
 * admin typed is shown exactly as typed — there's no way to translate it.
 *
 * The same map lives in user-service notificationMessages.js
 * (NotificationMessages.workflow.stepLabel) for notification text — keep the
 * two in sync.
 */

// Keys are lower-cased default step names.
export const WORKFLOW_STEP_NAMES_AR = {
  'first line manager approval': 'موافقة المدير المباشر',
  'first line manager acknowledgment': 'إقرار المدير المباشر',
  'second line manager approval': 'موافقة المدير الثاني',
  'assigned manager approval': 'موافقة المدير المُكلَّف',
  'admin approval': 'موافقة الإدارة',
};

// documentRequestService reports a finished workflow's "current step" as one
// of these status words instead of a step name.
const STATUS_WORDS_AR = {
  approved: 'تمت الموافقة',
  rejected: 'مرفوض',
};

/**
 * Arabic label for a known default step name, or null for any other name.
 * @param {string} stepName
 * @returns {string|null}
 */
export function getArabicStepName(stepName) {
  return WORKFLOW_STEP_NAMES_AR[String(stepName || '').trim().toLowerCase()] || null;
}

/**
 * A workflow step's name as it should be displayed in `language`.
 * @param {string} stepName
 * @param {string} language - 'ar' | 'en'
 * @returns {string}
 */
export function localizeWorkflowStepName(stepName, language) {
  const name = String(stepName ?? '').trim();
  if (!name || language !== 'ar') return name;
  const key = name.toLowerCase();
  return WORKFLOW_STEP_NAMES_AR[key] || STATUS_WORDS_AR[key] || name;
}
